export interface ExperienceEventSeoInterfaces {
  status: boolean;
  message: string | null;
  data: ExperienceEventSeoDataInterface;
}

export interface ExperienceEventSeoDataInterface {
  level: string;
  category: ExperienceCategory;
  subCategory: ExperienceSubCategory | null;
  subCategorys: ExperienceSubCategory[];
  sportTeams: ExperienceSportTeam[] | null;
  footballMatchHighlights: ExperienceFootballMatchHighlight[];
  footballMatchComings: ExperienceFootballMatchComing[];
}

export interface FootBallLists {
  title: string;
  imageUrl: string;
  url: string;
}

export interface ExperienceCategory {
  id: string;
  slug: string;
  name: string;
}

export interface ExperienceSubCategory {
  id: string;
  slug: string;
  name: string;
  image: string;
  isLeague: boolean;
}

export interface RequestEventSeoExperienceInterface {
  categorySlug?: string;
  subCategorySlug?: string;
}

export interface ExperienceSportTeam {
  id: string;
  slug: string;
  name: string;
  image: string;
  isRecommend: boolean;
}

export interface ExperienceFootballMatchHighlight {
  // เพิ่มโครงสร้างข้อมูลที่ใช้จริงใน footballMatchHighlights
}

// ประกาศอินเทอร์เฟซสำหรับทีมกีฬา
export interface ExperienceFootballSportTeam {
  id: string;
  slug: string;
  name: string;
  logo: string;
  banner: string | null;
}

// ประกาศอินเทอร์เฟซสำหรับประเทศ
export interface ExperienceFootballCountry {
  id: number;
  name: string;
  slug: string;
}

// ประกาศอินเทอร์เฟซสำหรับเมือง
export interface ExperienceFootballCity {
  id: number | null;
  name: string;
  slug: string | null;
}

// ประกาศอินเทอร์เฟซสำหรับหมวดหมู่
export interface ExperienceFootballCategory {
  id: number;
  name: string;
  slug: string;
}

// ประกาศอินเทอร์เฟซสำหรับหมวดหมู่ย่อย (subCategory)
export interface ExperienceFootballSubCategory {
  id: number;
  name: string;
  slug: string;
}

export interface ExperienceFootballMatchComing {
  name: string;
  eventId: string;
  date: string; // วันที่เป็น string ในรูปแบบ 'YYYY-MM-DD'
  time: string; // เวลาที่เป็น string ในรูปแบบ 'HH:mm'
  image: string;
  sportTeam: ExperienceFootballSportTeam;
  reviewRating: number | null;
  location: string;
  country: ExperienceFootballCountry;
  city: ExperienceFootballCity;
  category: ExperienceFootballSubCategory;
  subCategory: ExperienceFootballSubCategory;
}

export class ResponseExperienceEventSeoInterface {
  status: boolean;

  message: string | null;

  data: ExperienceEventSeoDataInterface;

  constructor(response: ExperienceEventSeoInterfaces) {
    this.status = response.status;
    this.message = response.message;
    this.data = {
      level: response.data.level,
      category: response.data.category,
      subCategory: response.data.subCategory,
      subCategorys: response.data.subCategorys,
      sportTeams: response.data.sportTeams,
      footballMatchHighlights: response.data.footballMatchHighlights || [], // ตั้งค่าเป็น array ว่างถ้าเป็น null
      footballMatchComings: response.data.footballMatchComings || [], // ตั้งค่าเป็น array ว่างถ้าเป็น null
    };
  }
}
